import { useEffect, useState } from "react";
import { getGenericRQScoringConfigById } from "../services/scoringService";

const useFetchGenericRQScoringConfigById = ({
  setIsLoading,
  configId,
}: any) => {
  const [configData, setConfigData] = useState<any>(null);

  useEffect(() => {
    if (configId) {
      setIsLoading(true);
      const fetchData = async () => {
        try {
          const result = await getGenericRQScoringConfigById(configId);
          setConfigData(result);
        } catch (err) {
          setConfigData(null);
        } finally {
          setIsLoading(false);
        }
      };
      fetchData();
    }
  }, [configId]);

  return [configData];
};

export default useFetchGenericRQScoringConfigById;

